/**
 *
 * the session key
 */
function sessionKey() {
    return `wvph-donate-general`;
}

/**
 *
 * check the session and return its value if it exist
 */
function getSessionToken(session_name = 'wvph-donate-general') {
    //const key = sessionKey();
    
    return localStorage.getItem(session_name);
}

/**
 *
 * get session token object
 */
function getSessionTokenObj(session_name = 'wvph-donate-general') {
    //const key = sessionKey();

    return { key : getSessionToken() };
}

/**
 *
 * set the session key val
 */
function setSessionToken(value, session_name = 'wvph-donate-general') {
    //const key = sessionKey();

    if (localStorage.getItem(session_name)) {
        localStorage.removeItem(session_name);
    }

    localStorage.setItem(session_name, value);
}

/**
 *
 * set the session key val
 */
function removeSessionToken(session_name = 'wvph-donate-general') {
    //const key = sessionKey();

    if (localStorage.getItem(session_name)) {
        localStorage.removeItem(session_name);
    }
}

const sessionService = {
    sessionKey,
    getSessionToken,
    getSessionTokenObj,
    setSessionToken,
    removeSessionToken
 }
 
 export default sessionService